import React from "react";
import { t } from "ttag";

import { AppState, ProgressItemState, getProgressBar } from "../engine";
import offStateSvg from "./off-state.svg";
import onStateSvg from "./on-state.svg";
import selectedSvg from "./selected.svg";
import skippedSvg from "./skipped.svg";

import styles from "./ProgressBar.module.scss";

/**
 * Progress bar above the Screen / Confirmation. Renders one item per
 * canonical spoke; hidden on populated walks and on non-walk views
 * (`getProgressBar` returns null in those cases).
 */
export type ProgressBarProps = { state: AppState };

const glyphSrc = (s: ProgressItemState): string => {
    switch (s) {
        case "completed":
            return selectedSvg;
        case "active":
            return onStateSvg;
        case "skipped":
            return skippedSvg;
        case "not-yet":
            return offStateSvg;
    }
};

export const ProgressBar = ({ state }: ProgressBarProps) => {
    const items = getProgressBar(state);
    if (!items) return null;
    return (
        <nav
            aria-label={t`Suite Builder progress`}
            className={styles.bar}
            style={{ "--spokes": items.length }}
        >
            {items.map((item) => (
                <span
                    key={item.spokeId}
                    aria-current={item.current ? "step" : undefined}
                    className={item.current ? styles.itemActive : styles.item}
                >
                    <img
                        aria-hidden
                        alt=""
                        src={glyphSrc(item.state)}
                        className={styles.glyph}
                    />
                    <span className={styles.label}>{item.label}</span>
                </span>
            ))}
        </nav>
    );
};
